import { IS_CLIENT, WIDGET_OPTIONS } from "../../../shared/config/constants";


// Constant variables from Drupal:
export let COSTS_RETENTION: number;
export let COSTS_MEASUREMENTS: number;
export let COSTS_RENT: number;
export let COSTS_GJ: number;

// If we provide the costs retention in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.costsRetention) {
  COSTS_RETENTION = Number(WIDGET_OPTIONS.heatCalculatorOptions.costsRetention);
}
// If we provide the costs measurements in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.costsMeasurements) {
  COSTS_MEASUREMENTS = Number(WIDGET_OPTIONS.heatCalculatorOptions.costsMeasurements);
}
// If we provide the costs rent in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.costsRent) {
  COSTS_RENT = Number(WIDGET_OPTIONS.heatCalculatorOptions.costsRent);
}
// If we provide the costs GJ in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.costsGj) {
  COSTS_GJ = Number(WIDGET_OPTIONS.heatCalculatorOptions.costsGj);
}

// Gas consumption variables from Drupal:
export let MIN_GAS_CONSUMPTION: number;
export let MAX_GAS_CONSUMPTION: number;
export let DEFAULT_GAS_CONSUMPTION: number;

// If we provide the min gas consumption in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.minGasConsumption) {
  MIN_GAS_CONSUMPTION = Number(WIDGET_OPTIONS.heatCalculatorOptions.minGasConsumption);
}
// If we provide the max gas consumption in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.maxGasConsumption) {
  MAX_GAS_CONSUMPTION = Number(WIDGET_OPTIONS.heatCalculatorOptions.maxGasConsumption);
}
// If we provide the default gas consumption in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.defaultGasConsumption) {
  DEFAULT_GAS_CONSUMPTION = Number(WIDGET_OPTIONS.heatCalculatorOptions.defaultGasConsumption);
}

// Gas price variables from Drupal:
export let MIN_GAS_PRICE: number;
export let MAX_GAS_PRICE: number;
export let DEFAULT_GAS_PRICE: number;

// If we provide the min gas price in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.minGasPrice) {
  MIN_GAS_PRICE = Number(WIDGET_OPTIONS.heatCalculatorOptions.minGasPrice);
}
// If we provide the max gas price in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.maxGasPrice) {
  MAX_GAS_PRICE = Number(WIDGET_OPTIONS.heatCalculatorOptions.maxGasPrice);
}
// If we provide the default gas price in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.defaultGasPrice) {
  DEFAULT_GAS_PRICE = Number(WIDGET_OPTIONS.heatCalculatorOptions.defaultGasPrice);
}

// Gas grid management cost variables from Drupal:
export let MIN_GAS_GRID_MANAGEMENT_COST: number;
export let MAX_GAS_GRID_MANAGEMENT_COST: number;
export let DEFAULT_GAS_GRID_MANAGEMENT_COST: number;

// If we provide the min gas grid management cost in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.minGasGridManagementCost) {
  MIN_GAS_GRID_MANAGEMENT_COST = Number(WIDGET_OPTIONS.heatCalculatorOptions.minGasGridManagementCost);
}
// If we provide the max gas grid management cost in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.maxGasGridManagementCost) {
  MAX_GAS_GRID_MANAGEMENT_COST = Number(WIDGET_OPTIONS.heatCalculatorOptions.maxGasGridManagementCost);
}
// If we provide the default gas grid management cost in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.defaultGasGridManagementCost) {
  DEFAULT_GAS_GRID_MANAGEMENT_COST = Number(WIDGET_OPTIONS.heatCalculatorOptions.defaultGasGridManagementCost);
}

// Gas fixed cost variables from Drupal:
export let MIN_GAS_FIXED_COST: number;
export let MAX_GAS_FIXED_COST: number;
export let DEFAULT_GAS_FIXED_COST: number;

// If we provide the min gas fixed cost in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.minGasFixedCost) {
  MIN_GAS_FIXED_COST = Number(WIDGET_OPTIONS.heatCalculatorOptions.minGasFixedCost);
}
// If we provide the max gas fixed cost in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.maxGasFixedCost) {
  MAX_GAS_FIXED_COST = Number(WIDGET_OPTIONS.heatCalculatorOptions.maxGasFixedCost);
}

console.log(WIDGET_OPTIONS);
// If we provide the default gas fixed cost in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.defaultGasFixedCost) {
  DEFAULT_GAS_FIXED_COST = Number(WIDGET_OPTIONS.heatCalculatorOptions.defaultGasFixedCost);
}

// CV installation cost variables from Drupal:
export let MIN_CV_INSTALLATION_COST: number;
export let MAX_CV_INSTALLATION_COST: number;
export let DEFAULT_CV_INSTALLATION_COST: number;

// If we provide the min cv installation cost in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.minCvInstallationCost) {
  MIN_CV_INSTALLATION_COST = Number(WIDGET_OPTIONS.heatCalculatorOptions.minCvInstallationCost);
}
// If we provide the max cv installation cost in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.maxCvInstallationCost) {
  MAX_CV_INSTALLATION_COST = Number(WIDGET_OPTIONS.heatCalculatorOptions.maxCvInstallationCost);
}
// If we provide the default cv installation cost in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.defaultCvInstallationCost) {
  DEFAULT_CV_INSTALLATION_COST = Number(WIDGET_OPTIONS.heatCalculatorOptions.defaultCvInstallationCost);
}

// CV maintenance cost variables from Drupal:
export let MIN_CV_MAINTENANCE_COST: number;
export let MAX_CV_MAINTENANCE_COST: number;
export let DEFAULT_CV_MAINTENANCE_COST: number;

// If we provide the min cv maintenance cost in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.minCvMaintenanceCost) {
  MIN_CV_MAINTENANCE_COST = Number(WIDGET_OPTIONS.heatCalculatorOptions.minCvMaintenanceCost);
}
// If we provide the max cv maintenance cost in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.maxCvMaintenanceCost) {
  MAX_CV_MAINTENANCE_COST = Number(WIDGET_OPTIONS.heatCalculatorOptions.maxCvMaintenanceCost);
}
// If we provide the default cv maintenance cost in the DOM, use that instead.
if (IS_CLIENT && WIDGET_OPTIONS?.heatCalculatorOptions?.defaultCvMaintenanceCost) {
  DEFAULT_CV_MAINTENANCE_COST = Number(WIDGET_OPTIONS.heatCalculatorOptions.defaultCvMaintenanceCost);
}

export const COSTS_VERDICT_AMOUNT: number = 50;
export const COSTS_VERDICT_CHEAP: COSTS_VERDICT = 'cheap';
export const COSTS_VERDICT_NEUTRAL: COSTS_VERDICT = 'neutral';
export const COSTS_VERDICT_EXPENSIVE: COSTS_VERDICT = 'expensive';
export type COSTS_VERDICT = 'cheap' | 'neutral' | 'expensive';

// Units.
export const UNIT_VOLUME = 'm\u00B3';
export const UNIT_PRICE = '€';

// Accuracies.
export const ACCURACY_VOLUME = 0;
export const ACCURACY_PRICE = 2;

export const SENTRY_DSN: string = 'https://837456027cd94e7fbee2c22c8a36e6d4@sentry.uncinc.nl/55';
